const STORAGE_KEY = 'flare.chat.canvasPanel.visibility.v1';
const DEFAULT_STATE = Object.freeze({
  closedSignalKey: '',
  lastSignalKey: '',
  visible: null,
});

function cleanText(value) {
  return String(value || '').trim();
}

function resolveStorage(storage) {
  if (storage) {
    return storage;
  }
  if (typeof window !== 'undefined' && window.localStorage) {
    return window.localStorage;
  }
  if (typeof globalThis !== 'undefined' && globalThis.localStorage) {
    return globalThis.localStorage;
  }
  return null;
}

function normalizeState(value) {
  const source = value && typeof value === 'object' && !Array.isArray(value) ? value : {};
  return {
    closedSignalKey: cleanText(source.closedSignalKey),
    lastSignalKey: cleanText(source.lastSignalKey),
    visible: typeof source.visible === 'boolean' ? source.visible : null,
  };
}

export function readCanvasPanelVisibilityState({ storage } = {}) {
  const targetStorage = resolveStorage(storage);
  if (!targetStorage) {
    return { ...DEFAULT_STATE };
  }
  try {
    return normalizeState(JSON.parse(targetStorage.getItem(STORAGE_KEY) || '{}'));
  } catch {
    return { ...DEFAULT_STATE };
  }
}

function writeCanvasPanelVisibilityState(patch = {}, { storage } = {}) {
  const targetStorage = resolveStorage(storage);
  if (!targetStorage) {
    return;
  }
  const nextState = normalizeState({
    ...readCanvasPanelVisibilityState({ storage: targetStorage }),
    ...patch,
  });
  try {
    targetStorage.setItem(STORAGE_KEY, JSON.stringify(nextState));
  } catch {
    // Persistence is best-effort UI state only.
  }
}

export function resolveInitialCanvasPanelOpen(options = {}) {
  return readCanvasPanelVisibilityState(options).visible === true;
}

export function persistCanvasPanelSignalKey(signalKey = '', options = {}) {
  const key = cleanText(signalKey);
  if (!key) {
    return;
  }
  writeCanvasPanelVisibilityState({ lastSignalKey: key }, options);
}

export function persistCanvasPanelVisibility(visible = false, options = {}) {
  const state = readCanvasPanelVisibilityState(options);
  const nextVisible = visible === true;
  writeCanvasPanelVisibilityState({
    closedSignalKey: nextVisible ? '' : state.lastSignalKey,
    visible: nextVisible,
  }, options);
}

export function shouldSuppressCanvasSignalOpen(signalKey = '', options = {}) {
  const key = cleanText(signalKey);
  const state = readCanvasPanelVisibilityState(options);
  return Boolean(key && state.visible === false && state.closedSignalKey === key);
}
